import axios from 'axios'

export default axios.create({
  baseURL: 'https://react-quizzzzzz-default-rtdb.firebaseio.com/'
})
